// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { threeVerticalLines16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-three-vertical-lines': IconThreeVerticalLines;
    }
}

/**
 * The icon component for the 'threeVerticalLines' icon
 */
export class IconThreeVerticalLines extends Icon {
    public constructor() {
        super(threeVerticalLines16X16);
    }
}

registerIcon('icon-three-vertical-lines', IconThreeVerticalLines);
export const iconThreeVerticalLinesTag = 'nimble-icon-three-vertical-lines';
